import type { HeadersDefaults } from 'axios'
import axios from 'axios'
// import { API_URL } from '@/configs';
import AuthService from '@/services/auth.service'

const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

http.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      AuthService.clearCache()
      return response
    }

    return response
  },
  async (error) => {
    const errMessage = axios.isAxiosError(error)
      ? typeof error.response?.data === 'string'
        ? error.response.data
        : 'Unknown Error'
      : 'Unknown Error'

    return Promise.reject(errMessage)
  },
)

function setHTTPHeader(header: HeadersDefaults['common']) {
  http.defaults.headers.common = { ...http.defaults.headers.common, ...header }
}

export { http, setHTTPHeader }
